export default __webpack_public_path__ + "static/media/person_1.625748c8.png";